import { FlowMappings, ProcessAction } from './actions.dictionary'
import { RuntimeComponentDefinition } from './custom-component.dictionary'
import { TemplateConfig } from './template-config.dictionary'

export enum UiFlowSessionState {
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
  TERMINATED = 'TERMINATED',
  EXPIRED = 'EXPIRED',
}

export type UiFlowSession = {
  id: string
  status: UiFlowSessionState
  expiryTime: string | null
}

/**
 * Why the UI flow renders the blocked screen instead of the flow.
 * 'access-denied' — the session in the URL belongs to another user (403 on status).
 * 'expired' — the session resolved (200) but its status is EXPIRED.
 * Both render FlxUiFlowAccessDeniedComponent / UiFlowAccessDenied; only the labels differ.
 */
export type UiFlowBlockedReason = 'access-denied' | 'expired'

/** Localized copy for the blocked screen; resolved per reason by getUiFlowBlockedLabels. */
export type UiFlowBlockedLabels = {
  title: string
  description: string
  cta: string
}

export enum WorkflowType {
  CHAT_BASED = 'CHAT_BASED',
  FLOW_BASED = 'FLOW_BASED',
}

export interface ChatWorkflow {
  appId?: string
  resDefId?: string
}

export type UiFlowTypeMetadata = {
  type: WorkflowType
  chatWorkflow: ChatWorkflow | null
}

export type UiFlowStartResponse = {
  id: string
  resourceId: string
  resourceDefinitionId: string
  name: string
  templateConfig: TemplateConfig[]
  global: TemplateConfig[]
  actions: ProcessAction[]
  data: Record<string, any>
  session: UiFlowSession
  customComponents: RuntimeComponentDefinition[]
  mappings?: FlowMappings
  ccMappings?: FlowMappings
  // keyed by `${reusableUiTemplateContext}:${componentFlowxUuid}`
  ccRutMappings?: FlowMappings
} & UiFlowTypeMetadata

export type UiFlowStatusResponse = UiFlowStartResponse

export type UiFlowUploadResponse = {
  filePath: string
  downloadPath: string
  originalFileName: string
  customComponents: RuntimeComponentDefinition[]
}

export type UiFlowUploadMultipleResponse = {
  documents: UiFlowUploadResponse[]
}
